import React from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component'

import { fetchPDP, receivePDPInfo, receiveVariantInfo, clearPDPInfo, trackPDPPageView } from '../pdp-actions';
import { fetchSlugInfo } from '../../page/page-actions'
import { PartialDataRead } from '../../caching/partial-data-store';
import { getPDPTitle, getProductDescription } from '../seo-helpers';

const PDP = loadable(() => import('./pdp'))
const PDP2 = loadable(() => import('../components-v2/index'))

/** TEMP AB TEST CODE */
const EXCLUSION_PRD_CLASS = { 'VGC': 1, 'PGC': 1, 'FIXEDBUNDLE': 1, 'PRT': 1 };
/**
 * Returns the templateKey of the pdp based on the product and variation.
 * This logic can be expanded to exclude other groups of products from the test
 * @param {} product 
 */
export const pdpTestLogic = (product, variation) => {
	if (variation === 'variation' && product.prdClass && !(product.prdClass in EXCLUSION_PRD_CLASS)) {
		return 'pdp-v2';
	} else {
		const { pdpConfig = {} } = product || {};
		return pdpConfig.templateKey;
	}
}

let PDPHASH = {};

export const isV2PDP = (slug, testVariation, slugInfo, pdp, product) => {
	const vanityUrl = `pdp/${slug}`;

	if(testVariation !== 'variation'){
		return false;
	}
	if (slug in PDPHASH) {
		let isV2 = PDPHASH[slug];
		if (Object.keys(PDPHASH).length > 50) {
			//once moving on to a new slug, clear out hash table
			PDPHASH = {
				[slug]: isV2
			};
		}
		return isV2;
	}
	if (slugInfo && slugInfo.vanityUrl === vanityUrl) {
		PDPHASH[slug] = true;
		return true;
	}
	if (product && product.slug === slug) {
		let isV2 = pdpTestLogic(product, testVariation) === 'pdp-v2';
		PDPHASH[slug] = isV2;
		return isV2;
	} else if (pdp && pdp.slug === slug) {
		let isV2 = pdpTestLogic(pdp, testVariation) === 'pdp-v2';
		PDPHASH[slug] = isV2;
		return isV2;
	}
	else {
		return false;
	}
}

const getPDPVariation = (state) => {
	const { testFlags } = state;
	const { ssrTest = {} } = testFlags;
	const { variation } = (ssrTest.pdpRedesign || {})
	return variation;
}

const mapABTestToProps = (state) => {
	const { pdp, slugInfo } = state;
	return {
		pdp,
		slugInfo,
		testVariation: getPDPVariation(state)
	};
};

const PDPABTestWrapper = connect(mapABTestToProps, null)(({ pdp, testVariation, slugInfo, ...rest }) => {
	const { match, product } = rest;
	let { slug } = match.params;
	let renderV2 = isV2PDP(slug, testVariation, slugInfo, pdp, product);

	if (renderV2) {
		return (<PDP2 {...rest} />);
	}
	return (<PDP {...rest} />);
});
/** END TEMP AB TEST CODE */

/**
 * Wrapper component to add PartialDataRead cache component
 */
class PDPCacheContainer extends React.Component {
	render() {
		let { product, match } = this.props;
		let { slug } = match.params;

		return (
			<PartialDataRead cacheKey={slug}>
				{(cacheValue) => {
					if (!product.sku && cacheValue) {
						product = Object.assign({}, product, cacheValue);
					}
					let newProps = { ...this.props, ...{ product } };
					return <PDPABTestWrapper {...newProps} />
				}}
			</PartialDataRead>
		);
	}
}

const mapStateToProps = (state) => {
	const { redirects, storeDomain, router, pdp: product } = state;
	const { location } = router;
	const { pathname } = location;
	const { error, seo = {} } = product; //change when backend updated
	// TODO: Check with SEO team if product.name should be used ? some slugs already contains sku number
	const title = getPDPTitle(product);
	const description = getProductDescription(product);
	const canonical = seo.canonical || `https://${storeDomain}${pathname}`;
	const keywords = seo.keywords;

	return {
		product,
		title,
		description,
		canonical,
		keywords,
		pageNotFound: !!error,
		redirects
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchPDP: (slug, filters) => dispatch(fetchPDP(slug, filters)),
		receivePDPInfo: product => dispatch(receivePDPInfo(product)),
		trackPDPPageView: product => dispatch(trackPDPPageView(product)),
		receiveVariantInfo: product => dispatch(receiveVariantInfo(product)),
		clearPDPInfo: () => dispatch(clearPDPInfo()),
	}
};

const loadData = async (params, store, query) => {
	const { dir, slug, filters } = params;
	const variation = getPDPVariation(store.getState());
	let pdp = await store.dispatch(fetchPDP(slug, filters, query));
	pdp = pdp.pdpInfo ? pdp.pdpInfo : pdp;
	const templateKey = pdpTestLogic(pdp, variation);

	if (templateKey === 'pdp-v2') {
		const fullSlug = `${dir}/${slug}`;
		//clear pdp info and only return slugInfo
		await store.dispatch(clearPDPInfo())
		return store.dispatch(fetchSlugInfo(fullSlug, { useGraphQL: true }));
	}
	return pdp;
};

export default {
	component: connect(mapStateToProps, mapDispatchToProps)(PDPCacheContainer),
	loadData
}
